import { Outlet } from 'react-router-dom'
import { useShow } from '@/contexts/ShowContext'
import { useUser } from '@/contexts/UserContext'
import Loader from '@/components/loader'
import Navbar from '@/components/Navbar'

export default function ShowLayout() {
    const { show } = useShow()
    const { user } = useUser()

    if (!show) {
        return (<Loader />)
    }

    return (
        <div className="flex h-screen w-screen overflow-hidden">
            {user && <Navbar />}
            <div className="flex flex-col h-screen w-full pl-20 overflow-hidden">
                <div className="flex flex-col flex-1 overflow-hidden relative">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}
